// extracted by mini-css-extract-plugin
module.exports = {"container":"GifCard_container__1qDnV","btnFav":"GifCard_btnFav__1Zo11"};